
  const __registry__ = require('../../../spiferack/client/index.js')
  function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var React = require('react');
var PropTypes = require('prop-types');
var connect = require('../../components/connect');
var ProfileTabs = require('../../components/profile/tabs');
var Orgs = require('../../components/profile/orgs');
var Packages = require('../../components/profile/packages');
var NextButton = require('../../components/profile/nextButton');
var Avatar = require('@npm/design-system/avatar/avatar');
var YourAccount = require('../../components/profile/yourAccount');
var Links = require('../../components/profile/links');
var _require = require('../../components/profile/containers'),
  Container = _require.Container,
  Content = _require.Content,
  Sidebar = _require.Sidebar;
var _require2 = require('../../utils/aria-live'),
  announce = _require2.announce;
var Profile = /*#__PURE__*/function (_React$Component) {
  "use strict";

  function Profile() {
    _classCallCheck(this, Profile);
    return _callSuper(this, Profile, arguments);
  }
  _inherits(Profile, _React$Component);
  return _createClass(Profile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      announce('Profile');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        profileScope = _this$props.scope,
        account = _this$props.account,
        orgs = _this$props.orgs,
        packages = _this$props.packages,
        user = _this$props.user,
        _this$props$activeTab = _this$props.activeTab,
        activeTab = _this$props$activeTab === void 0 ? 'packages' : _this$props$activeTab,
        dispatch = _this$props.dispatch,
        isAccountLinkEnabledForUser = _this$props.isAccountLinkEnabledForUser,
        _this$props$isTabPane = _this$props.isTabPanel,
        isTabPanel = _this$props$isTabPane === void 0 ? true : _this$props$isTabPane;
      var onClick = function onClick() {
        dispatch('SHOW_PACKAGES_LOADING');
        dispatch('FETCH_PACKAGES', {
          url: packages.urls.next
        });
      };
      var isCurrentUser = user && user.name === profileScope.parent.name;
      var scope = _objectSpread(_objectSpread({}, profileScope), {}, {
        isAccountLinkEnabledForUser: isAccountLinkEnabledForUser,
        isCurrentUser: isCurrentUser
      });
      return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Sidebar, null, scope.type === 'user' && /*#__PURE__*/React.createElement(Avatar, {
        src: scope.parent.avatars.large,
        href: "http://en.gravatar.com/emails/",
        size: 200,
        title: "",
        "aria-label": "Your profile picture"
      }), /*#__PURE__*/React.createElement(Links, {
        scope: scope
      }), isCurrentUser && /*#__PURE__*/React.createElement(YourAccount, {
        userName: user.name
      })), /*#__PURE__*/React.createElement(Content, null, scope.type === 'user' && /*#__PURE__*/React.createElement(ProfileTabs, {
        packageCount: packages.total,
        orgCount: orgs.total,
        active: activeTab
      }), activeTab === 'orgs' && /*#__PURE__*/React.createElement(Orgs, {
        orgs: orgs,
        isCurrentUser: isCurrentUser,
        isTabPanel: isTabPanel
      }), (activeTab === 'packages' || scope.type !== 'user') && [/*#__PURE__*/React.createElement(Packages, {
        packages: packages,
        isCurrentUser: isCurrentUser,
        isTabPanel: isTabPanel,
        isSubscribed: account.isSubscribed,
        scope: scope,
        key: "packages"
      }), packages.urls && /*#__PURE__*/React.createElement(NextButton, {
        key: "pagination",
        urls: packages.urls,
        onClick: onClick,
        loading: this.props.profilePackagesLoading
      })]));
    }
  }]);
}(React.Component);
Profile.propTypes = {
  scope: PropTypes.object,
  orgs: PropTypes.object,
  packages: PropTypes.object,
  isTabPanel: PropTypes.bool
};
Profile.defaultProps = {
  account: {},
  orgs: {
    total: 0,
    objects: []
  },
  packages: {
    total: 0,
    objects: []
  }
};
module.exports = connect()(Profile);
  let __hot__
  
  __registry__.register('profile/profile', module.exports, __hot__)
  